(async () => {
  const el = document.getElementById('lpu-registration-content')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */'src/pages/info/lpu-about/index.vue'),
    },
  ]

  await clientRender({ components })
})()
